import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c875035"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notation" }

import EditorControl from '@/components/editor/editor-control.vue';
import RnTextControlLoading from '@/components/rn-text-control-loading.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'notation-editor',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RnTextControlLoading),
    _createVNode(EditorControl)
  ]))
}
}

})